import {
  createShallowEqualSelector,
  getColorSelector,
  getSettingValueSelector,
  type SettingsPropsParametricSelector,
  TargetSelector
} from "@client/selectors";

export const makeBarStyleSelector = (): SettingsPropsParametricSelector => {
  const colorSelector = getColorSelector(TargetSelector.Entity, "barColor");

  return createShallowEqualSelector(
    [colorSelector],
    (color): React.CSSProperties => ({
      backgroundColor: color,
      width: "0%"
    })
  );
};

export const makeBarContainerStyleSelector = (): SettingsPropsParametricSelector => {
  const backgroundColorSelector = getColorSelector(TargetSelector.Entity, "barBackgroundColor");

  return createShallowEqualSelector(
    [backgroundColorSelector],
    (backgroundColor): React.CSSProperties => ({ backgroundColor })
  );
};

export const makeBarInnerStyleSelector = (): SettingsPropsParametricSelector => {
  const paddingSelector = getSettingValueSelector(TargetSelector.Entity, "barPadding");

  return createShallowEqualSelector(
    [paddingSelector],
    (padding): React.CSSProperties => ({
      padding
    })
  );
};
